import { archives } from "@/mocks/homeContent";

export default function ArchiveGrid() {
  return (
    <section id="archive" className="mx-auto max-w-7xl px-4 pb-14 md:px-6 md:pb-20">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs font-semibold tracking-[0.3em] text-primary-600">起底档案库 · 最新收录</p>
          <h3 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">近期入库档案</h3>
        </div>
        <a href="#review" className="whitespace-nowrap text-sm text-foreground-600 underline-offset-4 hover:text-primary-600 hover:underline">
          查看全部档案 <i className="ri-arrow-right-line align-middle" />
        </a>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {archives.map((a, i) =>
          a.size === "large" ? (
            <a
              key={a.title}
              href="#review"
              className="group overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300 sm:col-span-2 lg:col-span-2"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2">
                <div className="relative h-48 overflow-hidden sm:h-full">
                  <img
                    src={a.img}
                    alt={a.title}
                    className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-col justify-center p-5 md:p-7">
                  <span className="w-fit whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-[11px] font-medium tracking-wide text-secondary-900">
                    {a.tag}
                  </span>
                  <h4 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-xl">
                    {a.title}
                  </h4>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{a.excerpt}</p>
                  <span className="mt-4 text-xs text-foreground-500">{a.meta}</span>
                </div>
              </div>
            </a>
          ) : (
            <a
              key={a.title}
              href="#review"
              className="group flex flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className="w-fit whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-[11px] font-medium tracking-wide text-secondary-900">
                {a.tag}
              </span>
              <h4 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                {a.title}
              </h4>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{a.excerpt}</p>
              <span className="mt-auto pt-4 text-xs text-foreground-500">{a.meta}</span>
            </a>
          )
        )}
      </div>
    </section>
  );
}